import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, throwError } from 'rxjs';

import { AppConstants } from '../../shared/app.constants';
import { ErrorFactory, NetworkError, UnauthorizedError } from '../../shared/errors/app-error';
import { LoaderService } from '../services/loader.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const loaderService = inject(LoaderService);

  return next(req).pipe(
    catchError((error: unknown) => {
      loaderService.hide();

      // Convert to AppError
      const appError = ErrorFactory.fromHttpError(error);

      // Handle specific error types
      if (appError instanceof UnauthorizedError) {
        // Clear token and redirect to login
        localStorage.removeItem(AppConstants.USER_TOKEN_KEY);
        localStorage.removeItem(AppConstants.APP_CONTEXT_KEY);

        // Redirect to login with return URL
        const returnUrl = router.url;
        router.navigate(['/auth/login'], { queryParams: { returnUrl } });
        return throwError(() => appError);
      }

      if (appError instanceof NetworkError) {
        // Network errors - could show offline indicator
        console.warn('Network error detected:', appError.message);
      }

      // Re-throw the AppError for downstream handling
      return throwError(() => appError);
    }),
  );
};
